import { ReactNode } from 'react'
import { forceDark, forceLight } from 'utils'
import { Box } from '.'

interface ThemePreviewProps {
  children: ReactNode
  mode: 'dark' | 'light'
}
export default function ThemePreview({ children, mode }: ThemePreviewProps) {
  if (mode === 'light') {
    return (
      <Box
        {...forceLight}
        bg="linear-gradient(167deg, rgba(255, 255, 255, 0.70) 2.36%, rgba(255, 255, 255, 0.60) 92.17%)"
        borderRadius="lg"
        border="1px solid #FFF"
        display="flex"
        flex={1}
        flexDirection="column"
        gap={2}
        minW={0}
        p={4}
      >
        {children}
      </Box>
    )
  }
  return (
    <Box
      {...forceDark}
      bg="primary.600"
      borderRadius="lg"
      border="1px solid rgba(255, 255, 255, 0.1)"
      css={{ '& button': { color: 'white' }, '& button svg': { color: 'white' } }}
      display="flex"
      flex={1}
      flexDirection="column"
      gap={2}
      minW={0}
      p={4}
    >
      {children}
    </Box>
  )
}
